<template>
    <div class="stockScoreDetailRow">
        <div class="ssdrName">{{ subScoreName }}</div>
        <div class="ssdrValue">{{ subScoreValue }}</div>
    </div>
</template>

<script>
export default {
    props: ['scoreDetailRow'],
    computed: {
        subScoreName() {
            return this.$t(`subScore.${this.scoreDetailRow.name}`);
        },
        subScoreValue() {
            return this.scoreDetailRow.value ? Number(this.scoreDetailRow.value).toFixed(2) : "";
        }
    }
}
</script>

<style lang="scss" scoped>
.stockScoreDetailRow {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ssdrName {
        font-weight: bold;
    }
    .ssdrValue {
    }
}
</style>